import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import React__default__default, { useContext } from 'react';
import PropTypes__default from 'prop-types';
import styles from './autocomplete-selected-options.scss.js';
import HoneyBem from '../../../packages/honey-bem/honey-bem.js';
import { AutocompleteContext, AutocompleteSelectedOptionsContext } from '../autocomplete-context.js';
import Button from '../../button/button.js';
import Tag from '../../tag/tag.js';
import { Injecss } from '../../../packages/injecss/injecss.js';

var bem = HoneyBem.init('autocomplete-selected-list', styles);
var AutocompleteSelectedOptions = function (_a) {
  var deleteItemLabel = _a.deleteItemLabel,
    deleteAllItemsLabel = _a.deleteAllItemsLabel,
    _b = _a.extraClasses,
    extraClasses = _b === void 0 ? '' : _b,
    renderOption = _a.renderOption;
  // autocomplete context
  var _c = useContext(AutocompleteContext),
    containerId = _c.containerId,
    selectedOptions = _c.selectedOptions;
  var _d = useContext(AutocompleteSelectedOptionsContext),
    _e = _d.onDelete,
    onDelete = _e === void 0 ? function () {
      return null;
    } : _e,
    _f = _d.onReset,
    onReset = _f === void 0 ? function () {
      return null;
    } : _f;
  return /*#__PURE__*/React__default__default.createElement("div", {
    id: "autocomplete-selected-list-for-".concat(containerId),
    className: bem.b(false, extraClasses)
  }, selectedOptions && selectedOptions.length >= 1 && /*#__PURE__*/React__default__default.createElement(Button, {
    "aria-label": deleteAllItemsLabel,
    link: true,
    display: "square",
    size: "sm",
    extraClasses: bem.e('btn-reset'),
    type: "button",
    onClick: function () {
      onReset();
    }
  }), selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map(function (_a) {
    var title = _a.title,
      subtitle = _a.subtitle,
      key = _a.key,
      restItem = __rest(_a, ["title", "subtitle", "key"]);
    return /*#__PURE__*/React__default__default.createElement(Tag, {
      outlined: true,
      extraClasses: bem.e('item'),
      key: key || title,
      closeProps: {
        label: deleteItemLabel,
        onClick: function () {
          onDelete(__assign({
            title: title,
            subtitle: subtitle,
            key: key
          }, restItem));
        }
      }
    }, renderOption ? renderOption(__assign({
      title: title,
      subtitle: subtitle,
      key: key
    }, restItem)) : title);
  }));
};
AutocompleteSelectedOptions.displayName = 'AutocompleteSelectedOptions';
AutocompleteSelectedOptions.propTypes = {
  extraClasses: PropTypes__default.string,
  deleteAllItemsLabel: PropTypes__default.string.isRequired,
  deleteItemLabel: PropTypes__default.string.isRequired,
  renderOption: PropTypes__default.func
};
var autocompleteSelectedOptions = Injecss(AutocompleteSelectedOptions, styles);

export { AutocompleteSelectedOptions, autocompleteSelectedOptions as default };
